export default __webpack_public_path__ + "static/media/tete52.17609074.png";